import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const getSolutionAPI = async (headData, solutionId) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}

export const getSolutionsAPI = async (headData, payload) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/`,
        method: "GET",
        headers: headers,
        data: payload,
    });

    return response || null;
}

export const getSolutionVersionsAPI = async (headData, solutionId) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}/version`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}

export const deleteSolutionAPI = async (headData, solutionId) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}`,
        method: "DELETE",
        headers: headers,
    });

    return response || null;
}

export const createSolutionAPI = async (headData, payload) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/`,
        method: "POST",
        headers: headers,
        data: payload,
    });

    return response || null;
}

export const editSolutionAPI = async (headData, solutionId, payload) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}`,
        method: "POST",
        headers: headers,
        data: payload,
    });

    return response || null;
}

export const approveSolutionAPI = async (headData, solutionId, approvalDetails) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}/approve-reject`,
        method: "POST",
        headers: headers,
        data: approvalDetails
    });

    return response || null;
}

export const getSolutionsCategoriesAPI = async (headData, payload) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/lookup/solutions_category`,
        method: "GET",
        headers: headers,
        data: payload,
    });

    return response || null;
}

export const getLookupValuesAPI = async (headData, lookupType) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/lookup/${lookupType}`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}

export const getSolutionAllVersionsAPI = async (headData, solutionId) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/solution/${solutionId}/version`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}